"use client";
import { useJsApiLoader } from "@react-google-maps/api";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PlacesAutocomplete from "react-places-autocomplete";
import { featureService } from "services/FeatureService";

import "./SearchBar.scss";

const SearchBarPlaces = ({ handleChange, handleSelect, searchBarFilters }) => {

  const { t } = useTranslation();

  const [libraries] = useState(["places"]);
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: featureService.mapKey(),
    libraries,
  });
 
  return isLoaded ? (    
        <PlacesAutocomplete
        value={
            searchBarFilters?.locationSearchTerm ||
            ""
        }
        onChange={handleChange}
        onError={(e) => console.log(e)}
        debounce={500}
        clearItemsOnError={true}
        onSelect={handleSelect}
        >
        {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading,
        }) => (
            <div className="autocomplete-location location-radius">
            <input
                {...getInputProps({
                placeholder:
                    t("search_locations") +
                    "...",
                className:
                    "location-search-input",
                })}
            />
            <div className="autocomplete-dropdown-container">
                {loading && (
                <div>Loading...</div>
                )}
                {suggestions.map(
                (suggestion, index) => {
                    const className =
                    suggestion.active
                        ? "suggestion-item--active"
                        : "suggestion-item";
                    return (
                    <div
                        key={index}
                        {...getSuggestionItemProps(
                        suggestion,
                        {
                            className,
                        }
                        )}
                    >
                        <span>
                        {
                            suggestion.description
                        }
                        </span>
                    </div>
                    );
                }
                )}
            </div>
            </div>
        )}
        </PlacesAutocomplete>                                  
  ) : (
    <></>
  );
};

export default SearchBarPlaces;
